export default __webpack_public_path__ + "static/media/wa.b8b8a79c.png";